import ResourceShare from "./ResourceShare";

export default ResourceShare;
